
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextInput',
  props: {
    modelValue: {
      type: String,
      required: true,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onChanged(e: any): void {
      emit('update:modelValue', e.currentTarget.value)
    }

    return {
      onChanged
    }
  }
})
